import { render } from "./ProductWhoBought.vue?vue&type=template&id=60c01ce5&scoped=true"
import script from "./ProductWhoBought.vue?vue&type=script&lang=js"
export * from "./ProductWhoBought.vue?vue&type=script&lang=js"

import "./ProductWhoBought.vue?vue&type=style&index=0&id=60c01ce5&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c01ce5"]])

export default __exports__